function isIos() {
  return (
    /(iPad|iPhone|iPod)/gi.test(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
}

export const openLink = (link = {}) => {
  if (!link.url) return;

  const { url, target = '_self' } = link;
  const newWindow = window.open(url, target);

  // Safari/IOS "window.open" is blocked and returns null
  if (!newWindow || isIos()) {
    window.location.assign(url);
  } else {
    newWindow.focus();
  }
};
